<template>
  <Badge
    :label="$t(`components.filters.status.${status}`)"
    type="light"
    :color="color"
    :size="size"
    icon="dot"
  />
</template>

<script setup>
import { computed } from "vue";
import { Badge } from "@/SharedComponents/Badges";
import { statuses, sizes } from "@/SharedComponents/Badges/status";

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: (val) => statuses.includes(val),
  },
  size: {
    type: String,
    required: false,
    default: "sm",
    validator: (val) => sizes.includes(val),
  },
});

const color = computed(() => {
  switch (props.status) {
    case "open":
      return "gray";
    case "assigned":
      return "purple";
    case "scheduled":
      return "blue-light";
    case "completed":
      return "success";
    default:
      return "gray";
  }
});
</script>
